// src/services/resultsEventServices.js
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;
const resultsUrl = `${baseUrl}/api/results-events`;
const eventsUrl = `${baseUrl}/api/events`;
const token = localStorage.getItem("token");

/// GET
// Récupérer tous les résultats (optionnel: { q, limit, offset })
export const getAllResultsEvents = async (params = {}) => {
  try {
    const response = await axios.get(resultsUrl, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des résultats:", error);
  }
};

// Récupérer un ResultsEvent par ID
export const getResultsEventById = async (id) => {
  try {
    const response = await axios.get(`${resultsUrl}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du résultat:", error);
  }
};

// Récupérer tous les résultats d’un event_id (pas de FK)
export const getResultsByEventId = async (eventId) => {
  try {
    const response = await axios.get(`${eventsUrl}/${eventId}/results`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors du chargement des résultats de l'événement ${eventId}:`,
      error
    );
  }
};

/// POST
// Créer un ResultsEvent (payload complet)
export const createResultsEvent = async (data) => {
  try {
    const response = await axios.post(resultsUrl, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création du résultat:", error);
  }
};

// Créer un ResultsEvent à partir d’un Event (copie des champs)
export const createResultsEventFromEvent = async (eventId, links = {}) => {
  try {
    const response = await axios.post(
      `${eventsUrl}/${eventId}/results`,
      links, // ex: { rapport_url, tableaux_url, selection_url, photospodium_url }
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la création du résultat à partir de l'événement ${eventId}:`,
      error
    );
  }
};

/// PUT
// Mettre à jour un ResultsEvent (tous champs)
export const updateResultsEvent = async (id, data) => {
  try {
    const response = await axios.put(`${resultsUrl}/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du résultat:", error);
  }
};

/// PATCH
// Mettre à jour uniquement les liens (rapport_url, tableaux_url, selection_url, photospodium_url)
export const updateResultsEventLinks = async (id, links) => {
  try {
    const response = await axios.patch(`${resultsUrl}/${id}/links`, links, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour des liens du résultat:",
      error
    );
  }
};

/// DELETE
// Supprimer un ResultsEvent
export const deleteResultsEvent = async (id) => {
  try {
    const response = await axios.delete(`${resultsUrl}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du résultat:", error);
  }
};
